import httpHelper from "@/helpers/httpHelper";
import _ from "lodash"
// action types
export const GET_CREDITORS = "getCreditors";

// mutation types
export const SET_CREDITORS = "setCreditors";


export default {
    state: {

        balanceCreditors: null,
       
    },
    getters: {

        loadedBalanceCreditors(state) {
            return state.balanceCreditors;
        },

    },
    actions: {
        /**
         * Get the saman1 balance
         * @param state
         * @param payload
         */
        [GET_CREDITORS](state, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData(payload)
                    .then((response) => {
                        if (response.success){
                            let sum=_.sumBy(response.result.data, function(o) { return o.amount });
                            
                            state.commit(SET_CREDITORS, sum);
                        }
                            
                    })
                    .catch((error) => {
                    })
                    .finally(() => { });
            });
        },
       

    },
    mutations: {

        [SET_CREDITORS](state, payload) {
            state.balanceCreditors = payload;
        },
        

    }
};